
export default angular.module('userUtilities', [])
    /**
     * @ngdoc controller
     * @name userUtilities.controller:userUtilityNavigation
     * @description
     * Controls the current active utility
     */
    // @ngInject
    .controller('userUtilityNavigation', function ($scope) {
        $scope.active_utility = null;
        $scope.toggle = function (utility) {
            $scope.active_utility = utility === $scope.active_utility ? null : utility;
            angular.element(document.body)
                .toggleClass('user-utilities--active', $scope.active_utility !== null);
            return $scope.active_utility;
        };
    })
    /**
     * @ngdoc directive
     * @name userUtilities.directive:userUtilityNavigation
     * @restrict A
     * @description
     * Parent directive required to set the scope of a set of utilities
     */
    // @ngInject
    .directive('userUtilityNavigation', function () {
        return {
            scope: true,
            controller: 'userUtilityNavigation',
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                $scope.$watch('active_utility', function (active_utility) {
                    $element.toggleClass('user-utilities-container--active', active_utility !== null);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name userUtilities.directive:toggleUserUtility
     * @restrict A
     * @description
     * Toggles the state of a specific utility
     */
    // @ngInject
    .directive('toggleUserUtility', function (AnalyticsService) {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var utility = attrs.toggleUserUtility;
                $element.on('click touchend', function (e) {
                    // For mobile breakpoint we don't want to trigger the
                    // prevention, and let the page load normally
                    if ((window.innerWidth || document.body.clientWidth) < 610) {
                        return;
                    }
                    e.preventDefault();
                    $scope.$apply(function () {
                        $scope.toggle(utility);
                        var is_open = $scope.active_utility === utility;
                        AnalyticsService.trackPage(['/utilities', utility, is_open ? 'open' : 'close'].join('/'));
                    });
                });
                $scope.$watch('active_utility', function (active_utility) {
                    $element.toggleClass('navigation-item-link--active', active_utility === utility);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name userUtilities.directive:closeUserUtility
     * @restrict A
     * @description
     * Closes all user utilities within the current scope
     */
    // @ngInject
    .directive('closeUserUtility', function (AnalyticsService) {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var utility = attrs.toggleUserUtility;
                $element.on('click touchend', function (e) {
                    e.preventDefault();
                    $scope.$apply(function () {
                        var old_utility = $scope.active_utility;
                        $scope.toggle(null);
                        AnalyticsService.trackPage(['/utilities', old_utility, 'close'].join('/'));
                    });
                });
                $scope.$watch('active_utility', function (active_utility) {
                    $element.toggleClass('user-utilities-menu--active', active_utility === utility);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name userUtilities.directive:userUtility
     * @restrict A
     * @description
     * Sets the visibility of a user utility
     */
    // @ngInject
    .directive('userUtility', function () {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var utility = attrs.userUtility;
                $scope.$watch('active_utility', function (active_utility) {
                    // don't remove the active class unless another one
                    // is selected to ensure the close animation looks great
                    if (active_utility === null) {
                      return;
                    }
                    $element.toggleClass('user-utilities-menu--active', active_utility === utility);
                });
            }
        };
    });
